<template>
    <div :style="{ backgroundColor: background_color }" class="flex flex-row w-full items-center p-8 rounded-xl justify-between">
        <div class="flex flex-row align-middle items-center mr-5" style="width: 975px" @click="this.handleMenuClick">
            <img :src="getIcon(this.code)" class="w-14 h-14 ml-5" />
            <h2 class="text-3xl text-grey-darker ml-6">{{ this.title }}</h2>
        </div>

        <div class="flex flex-col text-right mr-3" @click="toggleVisibility">
            <div class="right flex flex-row items-center justify-end">
                <p class="text-2xl font-semibold text-grey-darker">Balance</p>
                <span><img class="w-8 h-8 ml-2"
                        :src="getIcon((this.is_visible && this.hide_balance) || !this.hide_balance ? 'password_visible' : 'password_invisible')" /></span>
            </div>
            <p class="text-5xl font-bold text-grey-darker">
                {{ (this.is_visible && this.hide_balance) || !this.hide_balance ? this.balance : maskedBalance }}
            </p>
        </div>
    </div>
</template>

<script>
import mixin from '@/mixins/controls.js';

export default {
    name: 'v-menu',
    mixins: [mixin],
    data() {
        return {
            is_visible: false,
        };
    },
    props: {
        code: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: '01/01/2024',
        },
        balance: {
            type: String,
            default: '',
        },
        background_color: {
            type: String,
            default: '#f4f5fb',
        },
        is_disabled: {
            type: Boolean,
            default: false,
        },
        hide_balance: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        maskedBalance() {
            return '******'
        },
    },
    watch: {
        hide_balance(new_value){
            if(new_value){
                this.is_visible = false;
            }
        }
    },
    methods: {
        toggleVisibility() {
            this.is_visible = !this.is_visible; 
        },
        handleMenuClick(){
            if(!this.is_disabled){
                this.$router.push({ name: 'transactions-page', params: { code: this.code, type: this.type } });
            }
        }
    },
};
</script>

<style>
.cursor-pointer {
    cursor: pointer;
}
</style>
